import React, {useEffect} from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Category from "../components/home/category";
import Banner from "../components/home/banner";
import CategoryImage from "../components/home/categoryImage";
import ProductOffers from "../components/home/oferta";
import ProductNews from "../components/home/novedades";
import ProductBestSelling from "../components/home/bestSelling";
import {get_homeStore} from "../redux/actions/home";
import Store from "../components/home/store";


const Home = ({ get_homeStore }) => {

    useEffect(() => {
        get_homeStore();
    }, []);

    return (
        <Layout>
            <main className="w-full min-h-screen bg-gray-50 flex flex-col gap-6 sm:gap-12 pb-8 sm:pb-16">
                <Banner/>
                <div className="max-w-7xl mx-auto w-full px-2 sm:px-6 lg:px-8 space-y-8 sm:space-y-16">
                    <Store/>
                    {/*<CategoryImage/>*/}
                    <ProductOffers/>
                    <ProductBestSelling/>
                    <ProductNews/>
                </div>
            </main>
        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, { get_homeStore })(Home)
